<template>
    <v-chip class="stamina-chip" color="primary" text-color="white" @click="goTransactions">
        {{stamina}} {{$t("Credits")}}
        <font-awesome-icon icon="coins" class="stamina-icon"/>
    </v-chip>
</template>

<script>

    import { VChip, VIcon } from 'vuetify/lib'

    export default {
        name: 'StaminaIndicator',
        components: {
            VChip, VIcon
        },
        data() {
            return {
                stamina: 0,
            }
        },
        created() {
            if (this.$user) {
                this.stamina = this.$user.stamina;
            }
            this.$root.$on('update-stamina', (event) => {
                this.stamina = event.value;
            });
        },
        methods: {
            goTransactions() {
                this.$router.push({name: 'transactions', params: {}});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .stamina-chip {
        margin-right: 15px;
    }
    .stamina-icon {
        margin-left: 10px;
        font-size: 18px;
    }
</style>